import { Chip } from '@apps/components/Chip';
import CloseIcon from '@mui/icons-material/Close';

import { QuickFilterButtonProps } from './props';

export const QuickFilterButton: React.FC<QuickFilterButtonProps> = (props) => {
  const { selected, label, ...rest } = props;
  return (
    <Chip
      variant={'outlined'}
      color={selected ? 'secondary' : 'default'}
      sx={{
        display: 'flex',
        textTransform: 'capitalize',
        minHeight: '32px',
      }}
      label={label}
      deleteIcon={
        <CloseIcon
          sx={{
            width: '16px',
            height: '16px',
            fill: '#000000',
          }}
        />
      }
      {...rest}
    />
  );
};

export default QuickFilterButton;
